import api from './api';

const athleteService = {
  /**
   * Search game results
   * @param {Object} filters - Search filters
   * @returns {Promise} API response
   */
  searchGameResults: async (filters) => {
    try {
      const response = await api.post('/athletes/search', filters);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get available filter options
   * @returns {Promise} API response
   */
  getFilterOptions: async () => {
    try {
      const response = await api.get('/athletes/filters');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * 取得有可統計成績的運動清單
   * @returns {Promise} API response
   */
  getStatsSports: async (gamesName) => {
    const response = await api.get('/athletes/stats/sports', {
      params: gamesName ? { games_name: gamesName } : {},
    });
    return response.data;
  },

  /**
   * 取得指定運動的項目清單
   * @param {string} sportChinese - 運動類別
   * @returns {Promise} API response
   */
  getStatsEvents: async (sportChinese, gamesName) => {
    const response = await api.get('/athletes/stats/events', {
      params: {
        sport_chinese: sportChinese,
        ...(gamesName ? { games_name: gamesName } : {}),
      },
    });
    return response.data;
  },

  /**
   * 取得項目歷年成績趨勢（各組別一條序列）
   * @param {string} sportChinese - 運動類別
   * @param {string} event - 項目
   * @returns {Promise} API response
   */
  getEventTrend: async (sportChinese, event, gamesName) => {
    const response = await api.get('/athletes/stats/event-trend', {
      params: {
        sport_chinese: sportChinese,
        event,
        ...(gamesName ? { games_name: gamesName } : {}),
      },
    });
    return response.data;
  },

  /**
   * 取得學校清單（指定運動類別時只回傳該運動有前八名成績的學校）
   * @param {string} [sportChinese] - 運動類別
   * @returns {Promise} API response
   */
  getSchools: async (sportChinese) => {
    const response = await api.get('/athletes/stats/schools', {
      params: sportChinese ? { sport_chinese: sportChinese } : {},
    });
    return response.data;
  },

  /**
   * 取得縣市單位清單（指定運動類別時只回傳該運動有前八名成績的縣市）
   * @param {string} [sportChinese] - 運動類別
   * @returns {Promise} API response
   */
  getCounties: async (sportChinese) => {
    const response = await api.get('/athletes/stats/counties', {
      params: sportChinese ? { sport_chinese: sportChinese } : {},
    });
    return response.data;
  },

  /**
   * 取得各縣市在指定運動的獎牌總覽（地圖著色用）
   * @param {string} sportChinese - 運動類別
   * @returns {Promise} API response
   */
  getCountyOverview: async (sportChinese, gamesName) => {
    const response = await api.get('/athletes/stats/county-overview', {
      params: {
        sport_chinese: sportChinese,
        ...(gamesName ? { games_name: gamesName } : {}),
      },
    });
    return response.data;
  },

  /**
   * 取得縣市單項運動實力分析（縣市代表隊＋該縣市所有學校）
   * @param {string} county - 縣市名稱
   * @param {string} sportChinese - 運動類別
   * @returns {Promise} API response
   */
  getCountySportStats: async (county, sportChinese, gamesName) => {
    const response = await api.get('/athletes/stats/county-sport', {
      params: {
        county,
        sport_chinese: sportChinese,
        ...(gamesName ? { games_name: gamesName } : {}),
      },
    });
    return response.data;
  },

  /**
   * 取得學校單項運動實力分析
   * @param {string} school - 學校名稱
   * @param {string} sportChinese - 運動類別
   * @returns {Promise} API response
   */
  getSchoolSportStats: async (school, sportChinese) => {
    const response = await api.get('/athletes/stats/school-sport', {
      params: { school, sport_chinese: sportChinese },
    });
    return response.data;
  },

  /**
   * Health check
   * @returns {Promise} API response
   */
  healthCheck: async () => {
    try {
      const response = await api.get('/athletes/health');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default athleteService;
